import * as amplitude from '@amplitude/analytics-browser';

export const AnalyticsEvents = Object.freeze({
	VALUE_ADDED_PROGRAM_VIEWED: 'clinical_value_added_program_viewed',
	VALUE_ADDED_VENDOR_SELECTED: 'clinical_value_added_vendor_selected',
	VALUE_ADDED_PROGRAM_LINK_CLICKED:
		'clinical_value_added_program_link_clicked',
	VALUE_ADDED_PROGRAM_EXITED_INTERNAL:
		'clinical_value_added_program_exited_internal',
});

export function trackAnalyticsEvent(eventName, eventProperties = {}) {
	try {
		amplitude.track(eventName, eventProperties);
	} catch (error) {
		console.debug(
			'Amplitude is not setup or not available right now.',
			error
		);
	}
}
